var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEmailIcon(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 29,
    height: 28,
    viewBox: "0 0 29 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4764_1341)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M26.8383 6.447L15.7905 15.596C15.4766 15.8561 15.0817 15.9984 14.674 15.9984C14.2663 15.9984 13.8715 15.8561 13.5575 15.596L2.51503 6.447C2.45578 6.62535 2.42565 6.81207 2.42578 7V21C2.42578 21.4641 2.61016 21.9092 2.93834 22.2374C3.26653 22.5656 3.71165 22.75 4.17578 22.75H25.1758C25.6399 22.75 26.085 22.5656 26.4132 22.2374C26.7414 21.9092 26.9258 21.4641 26.9258 21V7C26.9265 6.81217 26.8969 6.62544 26.8383 6.447ZM4.17578 3.5H25.1758C26.104 3.5 26.9943 3.86875 27.6507 4.52513C28.307 5.1815 28.6758 6.07174 28.6758 7V21C28.6758 21.9283 28.307 22.8185 27.6507 23.4749C26.9943 24.1313 26.104 24.5 25.1758 24.5H4.17578C3.24752 24.5 2.35728 24.1313 1.70091 23.4749C1.04453 22.8185 0.675781 21.9283 0.675781 21V7C0.675781 6.07174 1.04453 5.1815 1.70091 4.52513C2.35728 3.86875 3.24752 3.5 4.17578 3.5ZM3.80828 5.25L13.5663 13.3053C13.8788 13.5634 14.2712 13.705 14.6766 13.706C15.0819 13.7069 15.475 13.5672 15.7888 13.3105L25.6448 5.25H3.80828Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4764_1341"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 28,
    height: 28,
    fill: "white",
    transform: "translate(0.675781)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmailIcon);
export default __webpack_public_path__ + "static/media/emailIcon.7de532b86d17b1a65333eab85d2f3c86.svg";
export { ForwardRef as ReactComponent };